import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ArticleAvoidScams() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="bg-background-50">
      <article>
        <header className="w-full px-6 md:px-10 pt-24 pb-12 md:pt-32 md:pb-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-accent-500 transition-colors mb-6">
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
              <span>На главную</span>
            </Link>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">Защита</span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              Как избежать мошенничества при заказе из Китая: 7 правил
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-500 leading-relaxed">
              Распространённые схемы обмана при покупках из Китая и как YOYBUY Spreadsheet защищает ваш заказ на каждом этапе.
            </p>
            <div className="mt-6 flex items-center gap-4 text-xs text-foreground-400">
              <span>Обновлено: Июль 2026</span>
              <span>·</span>
              <span>Время чтения: 7 минут</span>
            </div>
          </div>
        </header>

        <div className="w-full px-6 md:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto">

            <img
              src="https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20warning%20sign%20on%20cardboard%20package%20box%2C%20fraud%20detection%20and%20investigation%20concept%2C%20dramatic%20warm%20amber%20accent%20lighting%20on%20red%20alert%20elements%2C%20investigative%20theme%2C%20consumer%20protection%20photography%2C%20alert%20and%20caution%20atmosphere%2C%20editorial%20consumer%20rights%20photography&width=1200&height=600&seq=yoybuy-art-scams-hero&orientation=landscape"
              alt="Как избежать мошенничества"
              className="w-full rounded-3xl mb-10 object-cover"
            />

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Распространённые схемы обмана</h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                Ежегодно тысячи покупателей теряют деньги при заказе товаров из Китая из-за мошеннических схем. Зная основные виды обмана и используя проверенные инструменты, такие как <strong>YOYBUY Spreadsheet</strong>, вы можете полностью исключить эти риски.
              </p>
              <div className="space-y-3 mt-6">
                {[
                  { scheme: 'Подмена товара', desc: 'Продавец отправляет дешёвую копию вместо заказанного товара. Фото на сайте не соответствует реальности.' },
                  { scheme: 'Фальшивые трек-номера', desc: 'Продавец предоставляет несуществующий трек-номер. Посылка никогда не отправляется, а деньги вернуть сложно.' },
                  { scheme: 'Скрытые комиссии', desc: 'После оплаты заказа выясняется, что нужно доплатить за «обработку», «упаковку» или «страховку», о которых не говорилось ранее.' },
                  { scheme: 'Исчезновение продавца', desc: 'После получения оплаты продавец перестаёт выходить на связь. Магазин может быть удалён с площадки.' },
                ].map((item, i) => (
                  <div key={i} className="p-4 bg-background-100 rounded-2xl flex items-start gap-3">
                    <i className="ri-error-warning-line text-red-400 mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-800">{item.scheme}</h4>
                      <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">7 правил защиты от мошенников</h2>
              <div className="space-y-4">
                {[
                  { rule: '1', title: 'Работайте через проверенные платформы', text: 'Используйте YOYBUY Spreadsheet и Kaspreadsheet. Товары в таблицах проходят предварительную проверку, что исключает риск столкнуться с мошенником. Не переходите по подозрительным ссылкам из писем и сообщений.' },
                  { rule: '2', title: 'Не ведитесь на слишком низкие цены', text: 'Если цена товара в 3-5 раз ниже рыночной, это почти наверняка мошенничество. В таблицах YOYBUY Spreadsheet все цены проверены и соответствуют реальным рыночным.' },
                  { rule: '3', title: 'Проверяйте рейтинг продавца', text: 'Перед заказом всегда изучайте историю продавца: количество успешных сделок, отзывы, дату регистрации. В таблицах YOYBUY эта информация уже учтена при отборе товаров.' },
                  { rule: '4', title: 'Используйте безопасную оплату', text: 'Никогда не переводите деньги напрямую на счёт продавца. Оплачивайте через платформу Kaspreadsheet, которая обеспечивает защиту платежа и возврат средств.' },
                  { rule: '5', title: 'Требуйте фото товара перед отправкой', text: 'Попросите продавца сделать реальные фото заказанного товара перед отправкой. Это поможет убедиться, что товар соответствует описанию.' },
                  { rule: '6', title: 'Сохраняйте всю переписку', text: 'Делайте скриншоты переписки с продавцом, сохраняйте подтверждения заказа и оплаты. В случае спора это будет вашим доказательством.' },
                  { rule: '7', title: 'Проверяйте трек-номер', text: 'Отслеживайте посылку с момента получения трек-номера. Если в течение 5-7 дней статус не обновляется, свяжитесь с поддержкой платформы.' },
                ].map((item) => (
                  <div key={item.rule} className="flex gap-4 p-5 bg-background-100 rounded-2xl">
                    <span className="flex-shrink-0 w-8 h-8 rounded-full bg-accent-500 text-background-50 flex items-center justify-center text-sm font-bold">{item.rule}</span>
                    <div>
                      <h4 className="text-base font-semibold text-foreground-800 mb-1">{item.title}</h4>
                      <p className="text-sm text-foreground-500 leading-relaxed">{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Как YOYBUY Spreadsheet исключает риски</h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                <Link to="/" className="text-accent-500 hover:underline">YOYBUY Spreadsheet</Link> создан с учётом всех основных рисков. Товары в таблицах проходят многоуровневую проверку: верификация продавца, подтверждение наличия, актуальность цен. Вы получаете только проверенные позиции от надёжных поставщиков.
              </p>
              <div className="p-5 bg-accent-50 rounded-2xl">
                <p className="text-sm text-accent-800 leading-relaxed">
                  <strong>Главный принцип:</strong> прозрачность — лучшая защита. Когда вы видите реальные цены, актуальное наличие и полную информацию о товаре, у мошенников просто не остаётся шансов.
                </p>
              </div>
            </section>

            <div className="mt-14 p-8 bg-primary-500 rounded-3xl text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">Защитите свои заказы</h2>
              <p className="text-base text-background-50/80 mb-6 max-w-md mx-auto">
                Используйте YOYBUY Spreadsheet для безопасных и выгодных покупок из Китая.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-7 py-3.5 rounded-full bg-background-50 text-primary-600 text-sm font-semibold hover:bg-accent-100 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>YOYBUY SHEET</span>
                  <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <Link to="/" className="px-7 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 text-sm font-semibold hover:border-background-50 hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>На главную</span>
                  <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>

            <div className="mt-10 pt-10 border-t border-background-200">
              <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-400 hover:text-accent-500 transition-colors">
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                <span>← Вернуться на главную страницу YOYBUY.PRO</span>
              </Link>
            </div>
          </div>
        </div>
      </article>

      <footer className="w-full px-6 md:px-10 py-10 bg-foreground-950">
        <div className="max-w-3xl mx-auto text-center">
          <Link to="/" className="text-xl font-heading font-bold text-background-50">YOYBUY<span className="text-accent-500">.PRO</span></Link>
          <p className="mt-3 text-xs text-background-50/30">© 2026 YOYBUY.PRO. Все права защищены.</p>
        </div>
      </footer>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org", "@type": "Article",
          "headline": "Как избежать мошенничества при заказе из Китая: 7 правил",
          "description": "Распространённые схемы обмана при покупках из Китая и как YOYBUY Spreadsheet защищает ваш заказ.",
          "datePublished": "2026-07-05", "dateModified": "2026-07-05",
          "author": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "publisher": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "mainEntityOfPage": {"@type": "WebPage", "@id": `${import.meta.env.VITE_SITE_URL}/article/avoid-china-scams`}
        })}
      </script>
    </main>
  );
}